import axios from "axios";
import { attachAuthRefresh } from "../utils/tokenRefresh";

// The wallet/payment endpoints live under the same host as the kundli app,
// one level up: .../api/kundli  ->  .../api/wallet
const KUNDLI_BASE = process.env.REACT_APP_API_BASE_URL || "";
const WALLET_BASE = KUNDLI_BASE.replace(/\/api\/kundli\/?$/, "/api/wallet");

export const walletApi = axios.create({
  baseURL: WALLET_BASE,
  headers: { "Content-Type": "application/json" },
});

walletApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("kc_access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Same auto-refresh-on-401 behavior as kundliApi.js — see utils/tokenRefresh.js.
attachAuthRefresh(walletApi);

const unwrap = (promise) =>
  promise
    .then((res) => res.data)
    .catch((err) => {
      const body = err.response?.data;
      const message =
        body?.error || body?.message || body?.detail || "Something went wrong.";
      throw { message, status: err.response?.status, body };
    });

// GET /api/wallet/get-astrologer-price/ -> { price: 99 }
export const getAstrologerPrice = () =>
  unwrap(walletApi.get("/get-astrologer-price/"));

// POST /api/wallet/recharge/  { amount }
// -> { order_id, amount, currency, key_id, user_phone }
export const createRazorpayOrder = (amount) =>
  unwrap(walletApi.post("/recharge/", { amount }));

// POST /api/wallet/recharge/  { type: 'astrologer_kundli' }
// Amount is decided server-side (settings.ASTROLOGER_KUNDLI_PAYMENT) — we
// don't send an amount at all for this flow.
// -> { order_id, amount, currency, key_id, user_phone }
export const createAstrologerOrder = () =>
  unwrap(walletApi.post("/recharge/", { type: "astrologer_kundli" }));

// POST /api/wallet/verify-payment/  { razorpay_order_id, razorpay_payment_id, razorpay_signature }
export const verifyRazorpayPayment = (payload) =>
  unwrap(walletApi.post("/verify-payment/", payload));
